export enum WarehouseRentalMenuEnum {
    overview = 0,
    retailUnitSize,
    properties
}
